/**
 * /api/db — runtime database health + integration verification (INFRA-160/162).
 *
 * getDbHealth() returnerar backend schemaCheck-rapporten.
 * testConnection(creds) kör engångs-ping mot alternativa credentials utan att
 * ändra appens runtime-config. Lösenord skickas bara över same-origin TLS.
 */

import { http } from './httpClient';

export async function getDbHealth() {
  const result = await http.get('/db/health');
  return result.data;
}

export async function testConnection({ host, port, database, user, password, ssl = false, target = null }) {
  const result = await http.post('/db/test-connection', {
    host, port, database, user, password, ssl, target,
  });
  return result.data;
}
